/**
 * It's a generated file, preferable to extend this in external file
 */
import {ServerTypeName} from 'common/enums';
import * as yup from 'common/yup';
import {passphrase} from 'common/yup/customs/passphrase';
import {AbstractServer} from '../Abstract/AbstractServer';
import {serverTypeNameSchema} from '../ServerTypeName';
import {enums} from 'types/enums';

export const ZohoWorkdriveNames = {
   clientId: 'clientId',
   clientSecret: 'clientSecret',
   authCode: 'authCode',
   teamFolderId: 'teamFolderId',
   authenticated: 'authenticated',
   teamFolderName: 'teamFolderName',
   regionCode: 'regionCode',
} as const;

export const ZohoWorkdriveServer = AbstractServer.shape({
   typeName: serverTypeNameSchema.default(ServerTypeName.WORKDRIVE),
   // ServerType: yup.string().oneOf(enums.ServerType).required(),
   [ZohoWorkdriveNames.clientId]: yup.idString().default(['']),
   [ZohoWorkdriveNames.clientSecret]: passphrase(),

   [ZohoWorkdriveNames.authCode]: passphrase(),
   [ZohoWorkdriveNames.teamFolderId]: yup.idString().default(['']),
   [ZohoWorkdriveNames.teamFolderName]: yup.string().default(''),

   [ZohoWorkdriveNames.regionCode]: yup
      .string()
      .oneOf(enums.regionCodes.keys)
      .default(enums.regionCodes.enum.US),
});
export type IZohoWorkdriveServer = yup.InferType<typeof ZohoWorkdriveServer>;
